import type { Listing } from '@thevillages/schemas';

import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  imports: [DatePipe],
  selector: 'app-listing-details-open-house',
  styleUrl: './open-house.css',
  templateUrl: './open-house.html',
})
export class ListingDetailsOpenHouse {
  public readonly listing = input.required<Listing>();
  public readonly openNow = input.required<boolean>();
}
